export const Preferences = Object.freeze({
  LocalStorageKey: 'preferences',
  VitalsRange: 'vitalsRange',
  TasksRange: 'tasksRange',
  TasksPreview: 'tasksPreview',
});

export const PreferenceKeys = Object.freeze({
  ContactsHeaders: 'contacts-headers',
  ContactFieldFavorites: 'contact-field-favorites',
  OrderedVitals: 'ordered-vitals',
  ContactDraggableCards: 'contact-draggable-cards',
  ReportingV2Headers: 'reporting-v2-headers',
});
